import { MbscResource } from '@mobiscroll/angular';

export interface LoadRosterDetailParams {
  date: string;
  employeeId: number;
}

export interface LoadRosterResourceParams {
  employeeId: number;
  begindate: string;
  enddate: string;
}

export abstract class RosterResourceRepository<T extends MbscResource, TDetail> {
  abstract load(params: LoadRosterResourceParams): Promise<T[]>;
  abstract loadDetail(params: LoadRosterDetailParams): Promise<TDetail>;
}
